export const ADMIN_USER: string = 'ADMIN';
export const NON_ADMIN_USER: string = 'NON_ADMIN';